import { HttpErrorStrategy } from './base-error.strategy';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export class DefaultError implements HttpErrorStrategy {
  handleError(error: HttpErrorResponse): Observable<never> {
    console.error('HTTP Error', error);
    console.log('Default error strategy invoked');
    return throwError(() => new Error('Something went wrong'));
  }
}
